import styled from 'styled-components';

const TableHeader = styled.div`
  display: flex;
  flex-direction: row;
  height: 32px;
  margin-bottom: 8px;
`;

const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  height: calc(100vh - 100px);
  width: 100%;
`;

export { ModalContent, TableHeader };
